"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutsideClickHandler = void 0;
const react_1 = require("react");
/**
 * useClickOutside takes a callback to handle click events outside of
 * the returned ref. Use this for things like dismissing a menu or modal when a
 * user clicks outside of the provided ref.
 *
 * Make sure to memoize the handler passed, else it will add unnecessary click handlers on document
 *
 * @example
 * function MyComponent() {
 *  const ref = useClickOutside<HTMLDivElement>(useCallback(() => {setSomething(true)}, [setSomething])
 *
 *  return (
 *    <div ref={ref}>Click outside me</div>
 *  )
 * }
 */
function useOutsideClickHandler(onOutsideClick) {
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const clickHandler = (e) => {
            const eventTarget = e.target;
            if (!ref.current || !(eventTarget instanceof HTMLElement)) {
                return;
            }
            if (ref.current !== eventTarget && !ref.current.contains(eventTarget)) {
                onOutsideClick();
            }
        };
        document.addEventListener("click", clickHandler);
        return () => {
            document.removeEventListener("click", clickHandler);
        };
    }, [onOutsideClick]);
    return ref;
}
exports.useOutsideClickHandler = useOutsideClickHandler;
//# sourceMappingURL=useOutsideClickHandler.js.map